import { HYDRATE } from 'next-redux-wrapper';
import { ParsedUrlQuery } from 'querystring';

import { RootState } from '../store';

export const INITIALISE = 'filters/INITIALISE';
export const UPDATE = 'filters/UPDATE';
export const RESET = 'filters/RESET';
export const SETENABLED = 'filters/SETENABLED';

export interface FiltersState {
    radius: DropDownFilter;
    minBedrooms: DropDownFilter;
    maxBedrooms: DropDownFilter;
    propertyType: DropDownFilter;
    minPrice: DropDownFilter;
    maxPrice: DropDownFilter;
    minPriceWeekly: DropDownFilter;
    maxPriceWeekly: DropDownFilter;
    minPriceMonthly: DropDownFilter;
    maxPriceMonthly: DropDownFilter;
    priceFrequency: DropDownFilter;
    propertySubTypes: MultiDropDownFilter;
    propertyAdded: DropDownFilter;
    availableFrom: DropDownFilter;
    underOfferOrSold: CheckBoxFilter;
    chainFree: CheckBoxFilter;
    priceReduced: CheckBoxFilter;
    includeSharedAccommodation: CheckBoxFilter;
    includeRented: CheckBoxFilter;
    furnishedState: DropDownFilter;
    billsIncluded: CheckBoxFilter;
    petsAllowed: CheckBoxFilter;
    rentalTerm: CheckBoxFilter;
    mustHaves: MultiDropDownFilter;
    isSharedOwnership: CheckBoxFilter;
    auction: CheckBoxFilter;
    retirementHome: CheckBoxFilter;
    newHomes: CheckBoxFilter;
    preOwned: CheckBoxFilter;
    incentives: CheckBoxFilter;
    duration: DropDownFilter;
    transportType: DropDownFilter;
    keywords: TextInputFilter;
    q: SimpleFilter;
    identifier: SimpleFilter;
    locationText: SimpleFilter;
}

export interface FiltersSelectedValues {
    [key: string]: string | boolean | string[] | Record<string, unknown>;
}

export type FilterTypes = keyof FiltersState;

type FilterOption = {
    label: string;
    value: string;
};
export type FilterOptions = FilterOption[];

// The filter object from the API
export type RawFilterFieldName = string | null;
export type RawFilterOptions = null | (string | null)[];
export type RawFilterValue = string | null | [] | boolean;

export type RawFilter = {
    group: string | null;
    fieldName: RawFilterFieldName;
    label: string | null;
    isRequired: boolean | null;
    inputType: string | null;
    placeholder: string | null;
    allowMultiple: boolean | null;
    options: RawFilterOptions;
    value: RawFilterValue;
};

export type DropDownFilter = {
    options: FilterOptions;
    selectedValue: string;
};

export type SimpleFilter = {
    selectedValue: string;
};

export type MultiDropDownFilter = {
    options: FilterOptions;
    selectedValue: string[];
};

export type CheckBoxFilter = {
    label: string;
    selectedValue: boolean;
    disabled?: boolean;
};

export type TextInputFilter = {
    label?: string;
    tip?: string;
    placeholder?: string;
    selectedValue: string;
};

export type Filter =
    | DropDownFilter
    | MultiDropDownFilter
    | CheckBoxFilter
    | TextInputFilter
    | SimpleFilter;

// Actions
export interface UpdateFilterAction<T extends FilterTypes = FilterTypes> {
    type: typeof UPDATE;
    filterType: T;
    selectedValue: FiltersState[T]['selectedValue'];
}

export interface InitialiseFiltersAction {
    type: typeof INITIALISE;
    filters: FiltersSelectedValues;
}

export interface ResetFiltersAction {
    type: typeof RESET;
    filters?: FilterTypes[];
    query?: ParsedUrlQuery;
}

export interface SetEnabledFilterAction {
    type: typeof SETENABLED;
}

interface HydrateFiltersAction {
    type: typeof HYDRATE;
    payload: RootState;
}

export interface FiltersValues {
    [key: string]: string;
}

export type FilterActionTypes =
    | UpdateFilterAction
    | InitialiseFiltersAction
    | ResetFiltersAction
    | HydrateFiltersAction
    | SetEnabledFilterAction;
